import type { GeometryPadWidgetConfig } from '../geometrypad.model';

/**
 * Composite figure: rectangle with triangles on two sides,
 * simulating an exam-style diagram.
 *
 * t1 on top edge: vertex A pinned to D via PointTarget.
 * t2 on right edge: vertex A pinned to B via PointTarget.
 */
export const COMPOSITE_FIGURE_PRESET: GeometryPadWidgetConfig = {
  id: 'composite-figure',
  type: 'geometrypad',
  params: {
    elements: {
      r1: {
        type: 'Rectangle',
        params: { w: 8, h: 5 },
      },
      t1: {
        type: 'Triangle',
        params: {
          a: 4,
          b: 5,
          c: 8,
          A: { x: 'r1.point.D.x', y: 'r1.point.D.y' },
        },
      },
      t2: {
        type: 'Triangle',
        params: {
          a: 4,
          b: 5,
          gamma: 70,
          A: { x: 'r1.point.B.x', y: 'r1.point.B.y' },
        },
      },
    },
  },
  display: {
    geometry: {
      shape: { coloring: true },
      label: { coloring: true },
    },
  },
};
